import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import * as moment from 'moment';
import { SessionService } from './session.service';

@Injectable({
  providedIn: 'root'
})
export class Utils {

  constructor(private sessionService: SessionService) {

  }
  static roundCurrency(value: number): number {
    let decimals = 2;
    return this.roundNumber(value, decimals);
  }

  static roundNumber(value: number, decimals: number): number {
    return Number(Math.round(parseFloat(value + 'e' + decimals)) + 'e-' + decimals);
  }

  static containsError(...controls: Array<AbstractControl>): boolean {
    let contains = false;
    if (controls) {
      for (var i = 0; i < controls.length; i++) {
        if (controls[i].errors) {
          contains = true;
          break;
        }
      }
    }
    return contains;
  }

  static stringToDate(strDate: any): Date {
    return new Date(moment(strDate).format())
  }

  static addMonthsDate(date: Date, months: number): Date {
    return moment(date).add(months, 'M').toDate();
  }

  static addDays(date: Date, number: number): Date {
    return moment(date).add(number, 'd').toDate();
  }

  public isOficina(): boolean {
    return this.sessionService.getTipoEmpresa() == 'OFICINA' ? false : true;
  }

  isOficinaCorreto(): boolean {
    return this.sessionService.getTipoEmpresa() == 'OFICINA';
  }

  isReguladora() {
    return this.sessionService.getTipoEmpresa() == 'REGULADORA';
  }
  restrictInputNumber(inputElement) {
    inputElement.addEventListener('input', function (event) {
      const inputValue = event.target.value;
      // Remove caracteres não numéricos
      const numericValue = inputValue.replace(/[^0-9]/g, '');
      // Garante que o valor não seja negativo
      if (numericValue.length > 0) {
        event.target.value = Math.abs(parseInt(numericValue, 10));
      } else {
        event.target.value = '';
      }
    });
  }

  uuidv4(str: string = 'xxxxxxxx') {
    return str
      .replace(/[xy]/g, function (c) {
        const r = Math.random() * 16 | 0,
          v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }
}

